import * as React from 'react'
import RootStyles from './SingleSelectDropDownInputField.styles'
import SingleLineInput from '../SingleLineInput/SingleLineInput'
import ArrowUp from '../Icons/Button/ArrowUp'
import ArrowDown from '../Icons/Button/ArrowDown'

type Props = {
  id: string,
  value: string,
  onChange: Function,
  placeholder?: string,
  isTouched?: boolean,
  isValid?: boolean,
  validationMessage?: string,
  disabled?: boolean,
  isOpen?: boolean,
  onOpen?: Function,
  onClose?: Function,
  icon?: React.ReactElement,
  [propName: string]: any, // for rest of parameters
}

const SingleSelectDropDownInputField = ({
  id,
  value,
  onChange,
  placeholder,
  isTouched,
  isValid,
  validationMessage,
  disabled,
  isOpen,
  onOpen,
  onClose,
  icon,
  ...rest
}: Props): React.ReactElement => {
  function renderRightIcon(className: string) {
    if (isOpen) {
      // @ts-ignore
      return <ArrowUp onClick={onClose} className={className} data-testid="arrow-up-icon" />
    }
    // @ts-ignore
    return <ArrowDown onClick={onOpen} className={className} data-testid="arrow-down-icon" />
  }

  return (
    <RootStyles icon={icon}>
      {icon && <span className="left-side-icon"> {icon} </span>}
      <SingleLineInput
        id={`${id}-input`}
        value={value}
        onChange={onChange}
        placeholder={placeholder || ''}
        isTouched={isTouched}
        isValid={isValid}
        disabled={disabled}
        validationMessage={validationMessage}
        autoComplete="off"
        autoCorrect="off"
        {...rest}
      />
      {renderRightIcon(`control-icon ${disabled ? 'disabled' : ''}`)}
    </RootStyles>
  )
}

SingleSelectDropDownInputField.defaultProps = {
  placeholder: '',
  isTouched: false,
  isValid: true,
  validationMessage: '',
  disabled: false,
  isOpen: false,
  onOpen: () => {},
  onClose: () => {},
  icon: null,
}

export default SingleSelectDropDownInputField
